// src/components/editProdForm.js
import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { getProduct, updateProduct, deleteProduct } from "../api";
import MachinesList1 from "./machineList";

const EditProdForm = () => {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const { id_prod } = useParams();

  const user = JSON.parse(localStorage.getItem("user"));
  const company = JSON.parse(localStorage.getItem("company"));

  const [codMaq, setCodMaq] = useState("");
  const [idProd, setIdProd] = useState(id_prod || "");
  const [model, setModel] = useState("");
  const [nameProd, setNameProd] = useState("");
  const [descProd, setDescProd] = useState("");
  const [unidad, setUnidad] = useState("u");
  const [ciclosHora, setCiclosHora] = useState("");
  const [undPorCiclo, setUndPorCiclo] = useState("");

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getProduct(company?.id_c, id_prod);
        if (!data) {
          alert(t("No se pudo cargar el producto"));
          return navigate(-1);
        }
        //       setCodMaq(data.cod_maq || "");
        setCodMaq(
          data.cod_maq === null || data.cod_maq === undefined ? "" : String(data.cod_maq)
        );
        setIdProd(data.id_prod || "");
        setModel(data.model ?? "");
        setNameProd(data.name_prod || "");
        setDescProd(data.description_prod || "");
        setUnidad(data.und_prod || "u");
        setCiclosHora(data.ciclo_x_hr_prod_std ?? "");
        setUndPorCiclo(data.und_prod_x_oper ?? "");
      } catch (e) {
        console.error("❌ Error getProduct:", e);
        alert(t("Ocurrió un error al cargar el producto."));
        return navigate(-1);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [company?.id_c, id_prod, navigate, t]);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        cod_maq: codMaq,
        model: model === "" ? null : Number(model),
        name_prod: nameProd,
        description_prod: descProd,
        und_prod: unidad,
        ciclo_x_hr_prod_std: ciclosHora === "" ? null : Number(ciclosHora),
        und_prod_x_oper: undPorCiclo === "" ? null : Number(undPorCiclo),
        // opcional: id_user: user?.id_u
      };
      const resp = await updateProduct(company?.id_c, idProd, payload);
      if (!resp) throw new Error("updateProduct returned null");
      alert(t("Producto actualizado"));
      navigate(-1);
    } catch (error) {
      console.error("❌ Error updateProduct:", error);
      alert(t("Ocurrió un error al actualizar el producto."));
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm(t("¿Eliminar este producto?"))) return;
    try {
      const resp = await deleteProduct(company?.id_c, idProd);
      if (!resp) throw new Error("deleteProduct returned null");
      alert(t("Producto eliminado"));
      navigate(-1);
    } catch (error) {
      console.error("❌ Error deleteProduct:", error);
      alert(t("Ocurrió un error al eliminar el producto."));
    }
  };

  if (loading) return <p className="box1">{t("Cargando...")}</p>;

  return (
    <div className="box1">
      <div className="box9">
        <form onSubmit={handleSave}>
          <table className="form1">
            <tbody>
              <tr>
                <td><label>{t("ID Producto")}</label></td>
                <td>
                  <input className="input1" value={idProd} disabled />
                </td>
              </tr>

              <tr>
                <td><label htmlFor="cod_maquina">{t("Código de Máquina")}</label></td>
                <td>
                 {/*} <MachinesList1
                    id_c={company?.id_c}
                    selectedValue={codMaq}
                    onSelect={(value) => setCodMaq(value)}
                  />*/}
   <input
      className="input1"
      type="text"
      value={codMaq}
      disabled
    />

                </td>
              </tr>

              <tr>
                <td><label htmlFor="model_product">{t("Modelo Prod")}</label></td>
                <td>
                  <input
                    className="input1"
                    type="number"
                    value={model}
                    onChange={(e) => setModel(e.target.value)}
                    id="model_product"
                    name="model_product"
                    required
                  />
                </td>
              </tr>

              <tr>
                <td><label htmlFor="nombre_producto">{t("Nombre de Producto")}</label></td>
                <td>
                  <input
                    className="input1"
                    type="text"
                    value={nameProd}
                    onChange={(e) => setNameProd(e.target.value)}
                    id="nombre_producto"
                    name="nombre_producto"
                    required
                  />
                </td>
              </tr>

              <tr>
                <td><label htmlFor="descripcion_producto">{t("Descripción de Producto")}</label></td>
                <td>
                  <textarea
                    className="input1"
                    id="descripcion_producto"
                    name="descripcion_producto"
                    rows="3"
                    value={descProd}
                    onChange={(e) => setDescProd(e.target.value)}
                    required
                  />
                </td>
              </tr>

              <tr>
                <td><label htmlFor="unidad">{t("Unidad de Producto")}</label></td>
                <td>
                  <select
                    className="input1"
                    value={unidad}
                    onChange={(e) => setUnidad(e.target.value)}
                    id="unidad"
                    name="unidad"
                    required
                  >
                    <option value="u">u (Unidades)</option>
                    <option value="m">m (Metros)</option>
                    <option value="kg">kg (Kilogramos)</option>
                    <option value="kit">Kit</option>
                  </select>
                </td>
              </tr>

              <tr>
                <td><label htmlFor="ciclos_hora">{t("Ciclos por Hora")}</label></td>
                <td>
                  <input
                    className="input1"
                    type="number"
                    value={ciclosHora}
                    onChange={(e) => setCiclosHora(e.target.value)}
                    id="ciclos_hora"
                    name="ciclos_hora"
                    min="0"
                    step="any"
                    required
                  />
                </td>
              </tr>

{/*}
              <tr>
                <td><label htmlFor="unidades_por_ciclo">{t("Unidades por Ciclo")}</label></td>
                <td>
                  <input
                    className="input1"
                    type="number"
                    value={undPorCiclo}
                    onChange={(e) => setUndPorCiclo(e.target.value)}
                    id="unidades_por_ciclo"
                    name="unidades_por_ciclo"
                    min="0"
                    required
                  />
                </td>
              </tr>

              */}
              {/* v2 */}
              <tr>
  <td><label htmlFor="unidades_por_ciclo">{t("Unidades por Ciclo")}</label></td>
  <td>
    <input
      className="input1"
      type="number"
      value={undPorCiclo}
      onChange={(e) => setUndPorCiclo(e.target.value)}
      id="unidades_por_ciclo"
      name="unidades_por_ciclo"
      min="0"
      step="any"
      required
    />
  </td>
</tr>



            </tbody>
          </table>

          <button type="submit" className="button7" disabled={saving}>
            {saving ? t("Guardando...") : t("Guardar")}
          </button>
          <button type="button" className="button7" onClick={() => navigate(-1)}>
            {t("Cancelar")}
          </button>
          <button type="button" className="buttonDel" onClick={handleDelete}>
            {t("Borrar")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditProdForm;
